/* eslint-disable react/prop-types */
import React from 'react';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from 'clsx';
// import './Button.scss';

// backgroundClass: bgLipstickOrangey || bgClearblue || square || bgGunmetalBluegrey
// href='https://www.facebook.com/'
// hasHref: if button is <a></a> href just only use background: 'bg-clearblue'

const useStyles = makeStyles((theme) => ({
  root: {},
  buttonComponent: {
    fontFamily: 'OpenSans',
    height: '52px',
    border: 'none',
    color: theme.palette.$white,
    outline: 'none !important',
    justifyContent: 'center !important',
    alignItems: 'center',
    backgroundColor: theme.palette.$ash100,
    display: 'inline-flex',
    position: 'relative',
    transition: 'background-color 1s ease',
    padding: '12px 24px',
    flexDirection: 'row',
    gap: '4px',
    borderRadius: '8px',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: theme.typography.$fzH4,
    lineHeight: theme.typography.$lhH4,
    cursor: 'pointer',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      borderRadius: '6px',
      opacity: 1,
      visibility: 'visible',
      transition: '0.5s all',
      zIndex: 1,
    },
    '& >*': {
      position: 'relative',
      zIndex: 2,
    },
  },

  buttonContent: {
    display: 'contents',
  },

  square: {
    backgroundColor: theme.palette.$lightWhite,
    border: `1px solid ${theme.palette.$ash100}`,
    color: theme.palette.$dark50,
    '&:hover': {
      backgroundColor: theme.palette.$ash100,
      color: theme.palette.$ash10,
    },
  },
  bgGunmetalBluegrey: {
    backgroundColor: theme.palette.$ash100,
    color: theme.palette.$ash10,
  },
  bgClearblue: {
    backgroundColor: theme.palette.$white,
    fontWeight: 600,
    fontSize: theme.typography.$fzH5,
    color: theme.palette.$clearBlue,
    border: `2px solid ${theme.palette.$clearBlue}`,
    '&:hover': {
      backgroundColor: theme.palette.$clearBlue,
      color: theme.palette.$white,
    },
  },
  link: {
    padding: 0,
    '& a': {
      padding: '18px 20px',
      width: '100%',
      display: 'flex',
      alignContent: 'center',
      textDecoration: 'none',
      fontWeight: '600',
      fontSize: theme.typography.$fzH4,
      color: theme.palette.$clearBlue,
      '&:hover': {
        color: theme.palette.$white,
      },
    },
  },
  disabled: {
    cursor: 'no-drop',
    backgroundColor: theme.palette.$lineBG,
    borderRadius: '8px',
    color: theme.palette.$lineGrey,
    '&:hover': {
      backgroundColor: theme.palette.$lineGrey,
      color: theme.palette.$lineBG,
    },
  },
  fullWidthMobile: {
    '@media (max-width: 767px)': {
      width: '100%',
      '& span': {
        display: 'block',
        width: '100%',
        textAlign: 'center',
      },
    },
  },
}));

const Button = ({
  onClick,
  children,
  backgroundClass,
  href,
  hasHref = false,
  target = '_blank',
  classNameCustom,
  disabled,
  fullWidthMobile,
  ...props
}) => {
  const classes = useStyles();
  return (
  // eslint-disable-next-line react/button-has-type,react/jsx-no-useless-fragment
    <>
      {
        !hasHref ? (
          // eslint-disable-next-line react/button-has-type
          <button
            className={clsx(
              classNameCustom,
              classes.buttonComponent,
              hasHref && classes.link,
              classes[backgroundClass],
              disabled && classes.disabled,
              fullWidthMobile && classes.fullWidthMobile,
            )}
            onClick={(e) => (!hasHref ? onClick(e) : console.log(''))}
            aria-hidden="true"
            disabled={disabled}
            {...props}
          >
            <span className={classes.buttonContent}>{children}</span>
          </button>
        ) : (
          <div className={clsx(
            classNameCustom,
            classes.buttonComponent,
            hasHref && classes.link,
            classes[backgroundClass],
            disabled && classes.disabled,
            fullWidthMobile && classes.fullWidthMobile,
          )}
          >
            <a href={href} target={target}>
              <span>{children}</span>
            </a>
          </div>
        )
      }
    </>

  );
};

Button.defaultProps = {
  onClick: () => null,
  href: '',
  hasHref: false,
  backgroundClass: '',
  target: '_blank',
};

Button.propTypes = {
  onClick: PropTypes.func,
  href: PropTypes.string,
  hasHref: PropTypes.bool,
  backgroundClass: PropTypes.string,
  target: PropTypes.string,
};

export default Button;
